import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CountryComponent } from './Country.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CountryComponent],
  exports: [CountryComponent],
})
export class CountryModule {}
